module.exports = __webpack_public_path__ + "img/f1-d.b855e50e.png";